// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__15kbb","version":"Menu_version__vAD25","menu":"Menu_menu__3qTEZ","buttonsContainer":"Menu_buttonsContainer__3rY0y"};